import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from "@angular/core";
import {AuditType, getProcessTypeForStandard, Order, ProcessType, Product} from "../../../../store/state/order.state";

@Component({
    selector: 'audit-dates',
    templateUrl: './audit-dates.template.html',
    styleUrls: ['./audit-dates.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AuditDatesComponent {

	@Input() order: Order;
	@Input() product: Product;
	@Input() clientLogged: boolean;

	isTransfer(product: Product): boolean {
		return getProcessTypeForStandard(product.standard) == ProcessType.TRANSFER;
	}

	isFirstYearInitial(product: Product): boolean {
		return getProcessTypeForStandard(product.standard) == ProcessType.INITIAL_CERTIFICATION && (product.currentAuditEvent == null || product.currentAuditEvent == AuditType.INITIAL_CERTIFICATION);
	}

	isRecertification(product: Product): boolean {
		return getProcessTypeForStandard(product.standard) == ProcessType.RECERTIFICATION;
	}
}
